import { Router } from '@reach/router';

import Button from '../../Button/Button';
import styles from '../SingleInputPage/SingleInputPage.module.scss';
import i18n from '../../../i18n';

export const Wrapper = ({ children }) => (
  <div style={{ height: '100%', position: 'relative' }}>{children}</div>
);

export const LinearLoadingWrapper = ({ children }) => (
  <div style={{ position: 'absolute', top: 0, height: '4px', width: '100%' }}>
    {children}
  </div>
);

export const SuggestButton = ({ onClick }) => (
  <div className={styles.suggestButton} style={{ pointerEvents: 'auto' }}>
    <Button type="primary" text={i18n.t('mapPage.suggestion')} onClick={onClick} />
  </div>
);

export const NoWorkshopViewContainer = ({ children }) => (
  <div
    style={{
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    {children}
  </div>
);

export const ContainerOverMap = ({ children }) => (
  <div
    className={styles.containerOverMap}
    style={{
      position: 'absolute',
      top: '4px',
      height: 'calc(100% - 4px)',
    }}
  >
    {children}
  </div>
);

export const LoadingBlur = () => (
  <div
    className={styles.loadingContainer}
    style={{ top: '4px', height: 'calc(100% - 4px)' }}
  ></div>
);

export const StyledRouter = ({ children }) => (
  <Router
    style={{
      width: '100vw',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
    }}
  >
    {children}
  </Router>
);
